export interface SalesOrderReportLineProcessing {
  processProductKey: string;
  processProductDescription: string;
  price: string;
  value: string;
  currencySymbol: string;
}
